<template>
  <div v-if="debugOn" class="debugListener" @click="clickDebug">DEBUG <small>( click )</small></div>
</template>

<script>
import DebugModal from "./Debug";
import { debugEnabled } from "@/utils";

export default {
  name: "DebugListener",
  data() {
    return {
      isDebugOpen: false,
      debugOn: debugEnabled()
    };
  },
  methods: {
    closeModal() {
      this.isDebugOpen = false;
      this.$modal.hide("debug-modal");
    },
    openModal() {
      this.isDebugOpen = true;
      this.$modal.show(
        DebugModal,
        {},
        {
          name: "debug-modal",
          height: "auto",
          width: 500,
          adaptive: true,
          scrollable: true
        }
      );
    },
    clickDebug() {
      this.isDebugOpen ? this.closeModal() : this.openModal();
    }
  }
};
</script>

<style scoped lang="scss">
.debugListener {
  position: fixed;
  top: 0px;
  background-color: aquamarine;
  z-index: 99999;
  width: 100%;
  text-align: center;
  color: black;
  cursor: pointer;
  padding: 5px;
  -webkit-box-shadow: 0px 10px 7px -2px rgba(138, 138, 138, 0.33);
  -moz-box-shadow: 0px 10px 7px -2px rgba(138, 138, 138, 0.33);
  box-shadow: 0px 10px 7px -2px rgba(138, 138, 138, 0.33);
}
</style>
